import { Directive, inject, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { DualCommunicatorService } from "../../services/internal-services/dual-communicator.service";
import { ToastService } from "../../services/internal-services/toast.service";
import { IVisionToast } from "../../interfaces/i-vision-toast";
import { INTERNAL_TOAST_TYPES, TOAST_STATUS } from "../../model/ToastConstants";
import { ToolbarService } from "../../services/internal-services/toolbar.service";
import { FeatureFlagsService } from "../../services/internal-services/feature-flags.service";
import { FeatureFlags } from "../../model/feature-flags";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";

@Directive()
export abstract class DualViewComponent implements OnInit, OnDestroy {
  viewerService = inject(VIEWER_SERVICE);

  protected constructor(
    protected dualCommunicatorService: DualCommunicatorService,
    private visionToastService: ToastService,
    protected toolbarService: ToolbarService,
    protected flagService: FeatureFlagsService,
  ) {}

  FeatureFlags = FeatureFlags;

  enabled: boolean;

  subscriptions: Subscription[] = [];

  ngOnInit() {
    this.subscriptions.push(
      this.dualCommunicatorService.dualEnabled$.subscribe((enabled) => {
        this.enabled = enabled;
      }),
    );

    this.subscriptions.push(
      this.viewerService.lockImageMode$.subscribe((active) => {
        if (active && this.enabled) {
          const message: IVisionToast = {
            id: "additional-images-disabled-dual",
            message: "SYNC view is unavailable while viewing Additional Images",
            type: INTERNAL_TOAST_TYPES.MAP_NOTIFICATIONS,
            timeout: 7000,
            status: TOAST_STATUS.WARNING,
          };
          this.visionToastService.setNotification(message);
        } else {
          this.visionToastService.removeNotificationsById("additional-images-disabled-dual");
        }
        this.dualCommunicatorService.updateAllowSync();
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  abstract changeDualViewStatus();
}
